/* eslint-disable import/prefer-default-export */

export const lotDataSelector = (state, { idlot, currency }) => state.indicator[idlot] && state.indicator[idlot][currency];
export const indicatorLoadingSelector = (state, { idlot }) => state.indicator[idlot].loading;
